// Local-only PIN/passcode helpers using Web Crypto PBKDF2.
// No server, no API — device-side only.

const PBKDF2_ITERATIONS = 150000;

function toBytes(str) {
  return new TextEncoder().encode(str);
}

function toHex(buf) {
  return Array.from(new Uint8Array(buf))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

function randomSalt(len = 16) {
  const a = new Uint8Array(len);
  crypto.getRandomValues(a);
  return toHex(a.buffer);
}

function hexToBytes(hex) {
  const a = new Uint8Array(hex.length / 2);
  for (let i = 0; i < a.length; i++) a[i] = parseInt(hex.substr(i * 2, 2), 16);
  return a;
}

export async function hashPin(pin, salt) {
  const usedSalt = salt || randomSalt();
  const baseKey = await crypto.subtle.importKey('raw', toBytes(pin), 'PBKDF2', false, ['deriveBits']);
  const bits = await crypto.subtle.deriveBits(
    {
      name: 'PBKDF2',
      hash: 'SHA-256',
      salt: hexToBytes(usedSalt),
      iterations: PBKDF2_ITERATIONS,
    },
    baseKey,
    256
  );
  return { hash: toHex(bits), salt: usedSalt };
}

export async function verifyPin(pin, salt, expectedHash) {
  const { hash } = await hashPin(pin, salt);
  // constant-time-ish compare
  if (hash.length !== expectedHash.length) return false;
  let ok = 0;
  for (let i = 0; i < hash.length; i++) ok |= hash.charCodeAt(i) ^ expectedHash.charCodeAt(i);
  return ok === 0;
}
